export default "__VITE_ASSET__BEmCGNSC__"